/* eslint-disable */
export const THEME_CHANGE_PALETTE = `[THEME] CHANGE PALETTE`;

export const THEME_CHANGE_PALETTE_TYPE_DARK = `[THEME] CHANGE PALETTE TYPE DARK`;
export const THEME_CHANGE_PALETTE_TYPE_LIGHT = `[THEME] CHANGE PALETTE TYPE LIGHT`;

export const THEME_TOGGLE_PALETTE_TYPE = `[THEME] TOGGLE PALETTE TYPE`;
